module.exports = __webpack_public_path__ + "img/Slideshow-biens-vendus-espace-client-immo.6584cd0c.png";